/* onia-recs 10/1/26: Make It A Set. A size tap adds that piece with a hidden order-line marker, then refreshes and opens
   the theme's cart drawer the way the theme's own Add to Cart does. Both boxes are drawn by Shopify (sections/
   make-it-a-set*.liquid) and fetched here, so the team's product template is never rewritten. Replaces LimeSpot. */
(function () {
  var MARK = { _from: 'Make It A Set' };
  var drawer = function () { return document.querySelector('[data-drawer="drawer-cart"]'); };

  function getCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mias-add]');
    if (!btn || btn.classList.contains('is-busy')) return;
    e.preventDefault();
    btn.classList.add('is-busy');
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-mias-add')), quantity: 1, properties: MARK }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed ' + r.status);
      return getCart();
    }).then(function (cart) {
      btn.classList.remove('is-busy'); btn.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      var d = drawer(); if (d) d.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    }).catch(function () {
      btn.classList.remove('is-busy'); btn.classList.add('is-error');
      setTimeout(function () { btn.classList.remove('is-error'); }, 2500);
    });
  });

  function section(url, id) {
    return fetch(url + (url.indexOf('?') < 0 ? '?' : '&') + 'section_id=' + id, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.text(); }) // a 503 is not "no set"
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mias]'); });
  }
  // Product page: fill LimeSpot's old slot (a Custom Liquid block in the team's product template).
  function fillPage() {
    var slot = document.querySelector('.related-products-limespot-product');
    if (!slot || slot.hasAttribute('data-mias-filled') || location.pathname.indexOf('/products/') < 0) return;
    slot.setAttribute('data-mias-filled', '');
    section(location.pathname, 'make-it-a-set').then(function (box) { if (box) slot.innerHTML = box.outerHTML; }, function () {});
  }
  // Cart drawer: a slot after the line items, created once.
  function drawerSlot() {
    var d = drawer(); if (!d) return null;
    var slot = d.querySelector('[data-mias-drawer]');
    if (!slot) { var form = d.querySelector('[data-cart-form]'); if (!form) return null;
      slot = document.createElement('div'); slot.setAttribute('data-mias-drawer', ''); form.after(slot); }
    return slot;
  }
  // Each tap fires two refreshes (cart change + drawer open). An older one never overwrites a newer one's box, and a failed
  // request writes nothing: on 10/1 a late 503 blanked a good box in WebKit.
  var calls = 0, shown = 0;
  function refreshDrawerBox(cart) {
    var slot = drawerSlot(); if (!slot) return;
    var me = ++calls, write = function (html) { if (me < shown) return; shown = me; slot.innerHTML = html; };
    if (!cart || !cart.items || !cart.items.length) { write(''); return; }
    // Newest item first; if its page has no set, try the next one (up to 3 items).
    var handles = cart.items.map(function (i) { return i.handle; }).filter(function (h, n, a) { return a.indexOf(h) === n; }).slice(0, 3);
    (function next(n) {
      if (n >= handles.length) { write(''); return; }
      section('/products/' + handles[n], 'make-it-a-set-drawer')
        .then(function (box) { if (box) write(box.outerHTML); else next(n + 1); }, function () {});
    })(0);
  }
  document.addEventListener('theme:cart:change', function (e) { refreshDrawerBox(e.detail && e.detail.cart); });
  function boot() {
    fillPage();
    var d = drawer();
    if (d) d.addEventListener('theme:drawer:open', function () { getCart().then(refreshDrawerBox, function () {}); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
